module.exports = __webpack_public_path__ + "img/video.8d35f9fb.png";